import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';

import { IUserOrganisationSelectOption } from '../interfaces/IUserOrganisationSelectOption';

export function createUserOrganisationSelectOption(org: IUserOrganisation): IUserOrganisationSelectOption {
  return {
    ...org,
    label: org.fullName,
    value: org.id,
  };
}
